module.exports = __webpack_public_path__ + "media/icon_transaction/bird_4-53b75e59.png";